import {useSearchParams} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {useEffect, useState} from "react";
import {Button, Card, Checkbox, Col, Divider, Row, Space, Spin, Typography} from 'antd';

const Unsubscribe = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const role = searchParams.get('role');
  const {t} = useTranslation();

  const [preferences, setPreferences] = useState(null);
  const [loading, setLoading] = useState(true);
  const [submitted, setSubmitted] = useState(false);

  const renterOptions = [
    {key: 'glitterFoundEmail', label: t('unsubscribe.renter.glitterFound')},
    {key: 'glitterApproachingEmail', label: t('unsubscribe.renter.glitterApproaching')},
    {key: 'glitterWritingEmail', label: t('unsubscribe.renter.glitterWriting')},
    {key: 'requestCanceledEmail', label: t('unsubscribe.renter.requestCanceled')},
    {key: 'reportReceivedEmail', label: t('unsubscribe.renter.reportReceived')},
  ];

  const glitterOptions = [
    {key: 'newRequestsEmail', label: t('unsubscribe.glitter.newRequest')},
    {key: 'newAppointmentsEmail', label: t('unsubscribe.glitter.newAppointment')},
    {key: 'appointmentApproachingEmail', label: t('unsubscribe.glitter.appointmentApproaching')},
    {key: 'appointmentCanceledEmail', label: t('unsubscribe.glitter.appointmentCanceled')},
    {key: 'successfulPayoutEmail', label: t('unsubscribe.glitter.payoutInProcess')},
  ];

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/api/user/notification?token=${token}`);
        const data = await res.json();
        setPreferences(data);
      } catch (e) {
        console.error("Failed to load notification preferences:", e);
      } finally {
        setLoading(false);
      }
    };

    if (token) fetchData();
  }, [token]);

  const renderCheckboxes = (options, dataSectionKey) => (
    <Row gutter={[0, 12]}>
      {options.map(({key, label}) => (
        <Col span={24} key={key}>
          <Checkbox
            checked={!!preferences?.[dataSectionKey]?.[key]}
            onChange={(e) => {
              setPreferences(prev => ({
                ...prev,
                [dataSectionKey]: {
                  ...prev?.[dataSectionKey],
                  [key]: e.target.checked
                }
              }));
            }}
          >
            {label}
          </Checkbox>
        </Col>
      ))}
    </Row>
  );

  if (loading) {
    return (
      <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '60vh'}}>
        <Spin size="large"/>
      </div>
    );
  }

  if (submitted) {
    return (
      <Card
        style={{
          maxWidth: 700,
          margin: '4rem auto',
          padding: '2rem',
          borderRadius: 12,
          boxShadow: '0 8px 24px rgba(0,0,0,0.1)',
          textAlign: 'center'
        }}
      >
        <Typography.Title level={2}>✅ {t('unsubscribe.header')}</Typography.Title>
        <Typography.Paragraph style={{fontSize: '16px'}}>
          {t('unsubscribe.confirmationMessage') || 'Vos préférences ont bien été enregistrées.'}
        </Typography.Paragraph>
      </Card>
    );
  }

  return (
    <Card
      style={{
        maxWidth: 700,
        margin: '4rem auto',
        padding: '2rem',
        borderRadius: 12,
        boxShadow: '0 8px 24px rgba(0,0,0,0.1)',
      }}
    >
      <Typography.Title level={2} style={{textAlign: 'center', marginBottom: '2rem'}}>
        {t('unsubscribe.header')}
      </Typography.Title>

      <Space direction="vertical" size="large" style={{width: '100%'}}>
        {(role === "renter" || role === "renterNglitter") && (
          <>
            {role === "renterNglitter" && (
              <Divider orientation="left">{t('unsubscribe.customer')}</Divider>
            )}
            {renderCheckboxes(renterOptions, 'renter')}
          </>
        )}

        {(role === "glitter" || role === "renterNglitter") && (
          <>
            {role === "renterNglitter" && (
              <Divider orientation="left">{t('unsubscribe.glitter')}</Divider>
            )}
            {renderCheckboxes(glitterOptions, 'glitter')}
          </>
        )}

        <Divider/>
        <Button
          type="primary"
          size="large"
          block
          onClick={async () => {
            try {
              await fetch(`${process.env.REACT_APP_API_URL}/api/user/notification?token=${token}`, {
                method: 'PUT',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify(preferences),
              });
              setSubmitted(true);
            } catch (error) {
              console.error('Failed to update notification preferences:', error);
            }
          }}
        >
          {t('unsubscribe.saveChanges')}
        </Button>
      </Space>
    </Card>
  );
};

export default Unsubscribe;